import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MsalInitService {
  constructor(private msalService: MsalService) {}
  initializeMsal(): Promise<void> {
    return firstValueFrom(this.msalService.initialize());
  }
}
